import { userSecurityPostureResponseSchema, userSecurityPostureParamsSchema, userSecurityPostureTableResponseSchema, userSecurityPostureFilterOptionsResponseSchema, } from '../contracts/user-security-posture';
import { serializeTableQueryParams, } from '../contracts/table';
import { parseSchema } from '../errors';
import { organizationIdSchema, } from '../contracts/organizations';
export async function getUserSecurityPosture(client, organizationId, params = {}) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedParams = parseSchema(userSecurityPostureParamsSchema, params);
    // Note: response is already the data (not AxiosResponse) due to the
    // response interceptor in client.ts that extracts response.data
    const response = await client.get(`/organizations/${validatedId}/user-security-posture`, { params: validatedParams });
    return parseSchema(userSecurityPostureResponseSchema, response);
}
/**
 * List user security posture data for the DataTable component.
 * Supports filtering (bracket notation), sorting, pagination, and search.
 *
 * Authorization: Owner/Manager only.
 */
export async function listUserSecurityPostureDataTable(client, organizationId, params = {}, options) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/user-security-posture/datatable`, {
        params,
        paramsSerializer: serializeTableQueryParams,
        signal: options?.signal,
    });
    return parseSchema(userSecurityPostureTableResponseSchema, response);
}
/**
 * Get distinct filter option values for a user security posture column.
 * Used by DataTable dynamic filter dropdowns.
 *
 * Authorization: Owner/Manager only.
 */
export async function getUserSecurityPostureFilterOptions(client, organizationId, params) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/user-security-posture/filter-options`, { params });
    return parseSchema(userSecurityPostureFilterOptionsResponseSchema, response);
}
//# sourceMappingURL=user-security-posture.js.map